import React from 'react';
import { ChevronRightSmall } from '@wix/wix-ui-icons-common';
import { useIcons } from '../../WixDesignSystemIconThemeProvider';

import { dataHooks } from '../constants';
import { classes } from '../SidebarSubMenuNext.st.css';

export type ExpandTrigger = 'click' | 'select';

export type CommonMenuProps = {
  title: React.ReactNode;
  suffix?: React.ReactNode;
  prefix?: React.ReactNode;
  children?: React.ReactNode;
  dataHook?: string;
  itemKey: string;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLElement>;
  onExpand?: (trigger: ExpandTrigger) => void;
  onCollapse?: (trigger: ExpandTrigger) => void;
  onQuickNavOpen?: () => void;
} & {
  [key: string]: any;
};

const ChevronSuffix = () => {
  const icons = useIcons('SidebarSubMenuNext', { ChevronRightSmall });

  return (
    <span className={classes.chevronRight}>
      <icons.ChevronRightSmall data-hook={dataHooks.chevronRight} size="18px" />
    </span>
  );
};

const chevronSuffixJsx = <ChevronSuffix key="chevron" />;

export const getSuffixWithChevron = (suffix: React.ReactNode) => {
  if (!suffix) {
    return chevronSuffixJsx;
  }

  return Array.isArray(suffix)
    ? [suffix[0], chevronSuffixJsx]
    : [suffix, chevronSuffixJsx];
};
